import React from 'react';
import { Switch, Redirect, Route, NavLink } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';

import CostingSummary from 'modules/costing-summary';
import CostingCreate from 'modules/costing-create';

import * as routes from 'routes';

const countries = {
  es: {
    title: 'Spain (ES)',
    url: `${routes.COSTING_ROUTE}/es`
  },
  uk: {
    title: 'United Kingdom (UK)',
    url: `${routes.COSTING_ROUTE}/uk`
  },
  fr: {
    title: 'France (FR)',
    url: `${routes.COSTING_ROUTE}/fr`
  },
  nl: {
    title: 'Netherlands (NL)',
    url: `${routes.COSTING_ROUTE}/nl`
  }
};

const CostingPage = React.memo(() => {
  return (
    <Container className="mt-4">
      <Row>
        <Col sm={3}>
          <Nav variant="pills" className="flex-column">
            {Object.keys(countries).map(country => (
              <Nav.Item key={country}>
                <Nav.Link as={NavLink} to={countries[country].url}>
                  {countries[country].title}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Col>
        <Col sm={9}>
          <Tab.Content>
            <Switch>
              <Redirect exact path={routes.COSTING_ROUTE} to={routes.COSTING_ROUTE_DEFAULT} />
              <Route exact path={`${routes.COSTING_ROUTE}/:country`} component={CostingSummary} />
              <Route
                exact
                path={`${routes.COSTING_ROUTE}/:country/create`}
                component={CostingCreate}
              />
            </Switch>
          </Tab.Content>
        </Col>
      </Row>
    </Container>
  );
});

export default CostingPage;
